import * as React from "react";
function SvgSettings(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.2 4.208a2 2 0 00-2-2h-2a2 2 0 00-2 2v.505a7.925 7.925 0 00-.123.047l-.471-.471a2 2 0 00-2.829 0L4.363 5.703a2 2 0 000 2.828l.357.357-.054.12H4a2 2 0 00-2 2v2a2 2 0 002 2h.504l.047.123-.47.471a2 2 0 000 2.829l1.414 1.414a2 2 0 002.828 0l.357-.357c.17.078.344.15.52.216v.504a2 2 0 002 2h2a2 2 0 002-2v-.666l.12-.054.357.357a2 2 0 002.828 0l1.415-1.414a2 2 0 000-2.829l-.471-.47.047-.124H20a2 2 0 002-2v-2a2 2 0 00-2-2h-.666a8.372 8.372 0 00-.054-.12l.357-.357a2 2 0 000-2.828l-1.415-1.414a2 2 0 00-2.828 0l-.194.194v-.275zM8.644 7.155l.047.047a5.964 5.964 0 012.509-.94V4.207h2v2.12c.766.156 1.48.457 2.109.874l1.5-1.5 1.413 1.415-1.451 1.452c.54.706.926 1.536 1.109 2.44H20v2h-2.053a5.964 5.964 0 01-.941 2.508l1.5 1.5-1.415 1.414-1.452-1.452a5.972 5.972 0 01-2.439 1.11v2.12h-2v-2.054a5.97 5.97 0 01-2.84-1.176L6.91 18.43l-1.414-1.414 1.5-1.5a5.964 5.964 0 01-.942-2.509H4v-2h2.12A5.973 5.973 0 017.23 8.57L5.776 7.117l1.415-1.414 1.452 1.452zM11 12.208a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgSettings);
export default ForwardRef;
